export default __webpack_public_path__ + "static/media/men12.46b512b5.jpg";